export const types = {
  button: 'button',
  submit: 'submit',
  reset: 'reset'
};
export const kinds = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary',
  danger: 'danger'
};